import { MediaTablet } from "api/const/MediaQuery"
import { LoginType } from "components/types/Context"
import useMediaQuery from "hook/useMediaQuery"
import { useContext, useMemo } from "react"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { EditCorporateProfile, EditStartupProfile } from "../EditProfile"


export const UserEditProfile = ()=>{
    const {loginType}= useContext(AppGeneralContext)

    const showEditProfile =  useMemo(()=>{
        if(loginType === LoginType.corporate){
            return <EditCorporateProfile/> 
        }else{
            return <EditStartupProfile/>
        }
    },[ loginType])


  return (
    <div>
       {showEditProfile}  
    </div>
  ) 
}